export const LOAD_CANDIDATES = "LOAD_CANDIDATES";
export const LOAD_CANDIDATES_ALL = "LOAD_CANDIDATES_ALL";
export const LOAD_CLIENTS_ALL = "LOAD_CLIENTS_ALL";
export const LOAD_CLIENTUSERS_ALL = "LOAD_CLIENTUSERS_ALL";

export const LOAD_CANDIDATE = "LOAD_CANDIDATE";
export const LOAD_CANDIDATE_HISTORY = "LOAD_CANDIDATE_HISTORY";
export const LOAD_CANDIDATE_CLIENTPREFERENCES =
  "LOAD_CANDIDATE_CLIENTPREFERENCES";
export const LOAD_CLIENT_CLIENTPREFERENCES = "LOAD_CLIENT_CLIENTPREFERENCES";
export const LOAD_CANDIDATE_JOBROLES = "LOAD_CANDIDATE_JOBROLES";
export const LOAD_CANDIDATE_AVAILABILITY = "LOAD_CANDIDATE_AVAILABILITY";
export const LOAD_CANDIDATE_BOOKINGDAYS = "LOAD_CANDIDATE_BOOKINGDAYS";

export const LOAD_CANDIDATE_JOBROLESFULLLIST =
  "LOAD_CANDIDATE_JOBROLESFULLLIST";
export const LOAD_CANDIDATE_DISQUALIFICATIONDECLARATIONS =
  "LOAD_CANDIDATE_DISQUALIFICATIONDECLARATIONS";
export const SAVE_CANDIDATE = "SAVE_CANDIDATE";
export const UPDATE_CANDIDATE_INTERVIEW = "UPDATE_CANDIDATE_INTERVIEW";
export const UPDATE_CANDIDATE_AVAILABILITY = "UPDATE_CANDIDATE_AVAILABILITY";

export const CREATE_COURSE = "CREATE_COURSE";
export const LOAD_COURSES_SUCCESS = "LOAD_COURSES_SUCCESS";
export const LOAD_AUTHORS_SUCCESS = "LOAD_AUTHORS_SUCCESS";
export const CREATE_COURSE_SUCCESS = "CREATE_COURSE_SUCCESS";
export const UPDATE_CANDIDATE_PROFILE_SUCCESS =
  "UPDATE_CANDIDATE_PROFILE_SUCCESS";
export const UPDATE_CANDIDATE_PICTURE_SUCCESS =
  "UPDATE_CANDIDATE_PICTURE_SUCCESS";
export const LOAD_CANDIDATE_SUCCESS = "LOAD_CANDIDATE_SUCCESS";
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";

export const LOAD_INTERNALUSER = "LOAD_INTERNALUSER";
export const LOAD_INTERNALUSERS = "LOAD_INTERNALUSERS";
export const UPDATE_INTERNALUSER_AVATAR = "UPDATE_INTERNALUSER_AVATAR";
export const CREATE_CANDIDATE_DOCUMENT = "CREATE_CANDIDATE_DOCUMENT";
export const LOAD_CANDIDATE_DOCUMENTS = "LOAD_CANDIDATE_DOCUMENTS";
export const UPDATE_CANDIDATE_DOCUMENT = "UPDATE_CANDIDATE_DOCUMENT";
export const LOAD_CANDIDATE_CHAT = "LOAD_CANDIDATE_CHAT";
export const CREATE_CANDIDATE_CHAT = "CREATE_CANDIDATE_CHAT";

export const LOAD_OVERSEASPOLICECHECKS = "LOAD_OVERSEASPOLICECHECKS";
export const UPDATE_OVERSEASPOLICECHECK = "UPDATE_OVERSEASPOLICECHECK";
export const CREATE_OVERSEASPOLICECHECK = "CREATE_OVERSEASPOLICECHECK";
export const DELETE_OVERSEASPOLICECHECK = "DELETE_OVERSEASPOLICECHECK";
export const UPDATE_OVERSEASPOLICECHECKREQUIRED =
  "UPDATE_OVERSEASPOLICECHECKREQUIRED";

export const LOAD_QUALIFICATIONS = "LOAD_QUALIFICATIONS";
export const UPDATE_QUALIFICATION = "UPDATE_QUALIFICATION";
export const CREATE_QUALIFICATION = "CREATE_QUALIFICATION";
export const DELETE_QUALIFICATION = "DELETE_QUALIFICATION";
export const UPDATE_QUALIFICATIONSCOMPLETE = "UPDATE_QUALIFICATIONSCOMPLETE";

export const LOAD_WORKHISTORY = "LOAD_WORKHISTORY";
export const UPDATE_WORKHISTORY = "UPDATE_WORKHISTORY";
export const CREATE_WORKHISTORY = "CREATE_WORKHISTORY";
export const DELETE_WORKHISTORY = "DELETE_WORKHISTORY";
export const UPDATE_WORKHISTORYCOMPLETE = "UPDATE_WORKHISTORYCOMPLETE";

export const LOAD_REFERENCES = "LOAD_REFERENCES";
export const UPDATE_REFERENCE = "UPDATE_REFERENCE";
export const CREATE_REFERENCE = "CREATE_REFERENCE";
export const DELETE_REFERENCE = "DELETE_REFERENCE";
export const UPDATE_REFERENCESCOMPLETE = "UPDATE_REFERENCESCOMPLETE";
export const SEND_REFERENCE_REQUEST = "SEND_REFERENCE_REQUEST";

export const LOAD_DBSCHECKS = "LOAD_DBSCHECKS";
export const UPDATE_DBSCHECK = "UPDATE_DBSCHECK";
export const CREATE_DBSCHECK = "CREATE_DBSCHECK";
export const CREATE_UPDATESERVICECHECK = "CREATE_UPDATESERVICECHECK";
export const LOAD_HEALTHDECLARATIONS = "LOAD_HEALTHDECLARATIONS";
export const UPDATE_HEALTHDECLARATION = "UPDATE_HEALTHDECLARATION";

export const LOAD_RTWCHECKS = "LOAD_RTWCHECKS";
export const UPDATE_RTWCHECK = "UPDATE_RTWCHECK";
export const CREATE_RTWCHECK = "CREATE_RTWCHECK";
export const DELETE_RTWCHECK = "DELETE_RTWCHECK";

export const LOAD_CANDIDATE_COMPLIANCESTATUS =
  "LOAD_CANDIDATE_COMPLIANCESTATUS";

export const UPDATE_CANDIDATEJOBROLE = "UPDATE_CANDIDATEJOBROLE";
// By convention, actions that end in "_SUCCESS" are assumed to have been the result of a completed
// API call. But since we're doing an optimistic delete, we're hiding loading state.
// So this action name deliberately omits the "_SUCCESS" suffix.
// If it had one, our apiCallsInProgress counter would be decremented below zero
// because we're not incrementing the number of apiCallInProgress when the delete request begins.
export const DELETE_COURSE_OPTIMISTIC = "DELETE_COURSE_OPTIMISTIC";

export const LOAD_CLIENTS = "LOAD_CLIENTS";
export const LOAD_CLIENT = "LOAD_CLIENT";
export const CREATE_CLIENT = "CREATE_CLIENT";
export const UPDATE_CLIENTPROFILE = "UPDATE_CLIENTPROFILE";

export const CREATE_HISTORY = "CREATE_HISTORY";
export const LOAD_CLIENT_HISTORY = "LOAD_CLIENT_HISTORY";
export const LOAD_CLIENTGUIDE_DOCUMENTS = "LOAD_CLIENTGUIDE_DOCUMENTS";
export const CREATE_CLIENTGUIDE_DOCUMENT = "CREATE_CLIENTGUIDE_DOCUMENT";
export const UPDATE_CLIENTGUIDE_DOCUMENT = "UPDATE_CLIENTGUIDE_DOCUMENT";
export const CREATE_CLIENTUSER = "CREATE_CLIENTUSER";
export const LOAD_CLIENTUSERS = "LOAD_CLIENTUSERS";
export const UPDATE_CLIENTUSER = "UPDATE_CLIENTUSER";

export const UPDATE_CLIENTUSER_SETINVOICECONTACT =
  "UPDATE_CLIENTUSER_SETINVOICECONTACT";

export const UPDATE_CLIENTUSER_SETPRIMARYCONTACT =
  "UPDATE_CLIENTUSER_SETPRIMARYCONTACT";
export const CREATE_CLIENT_ADDCLIENTUSER = "CREATE_CLIENT_ADDCLIENTUSER";
export const DELETE_CLIENT_CLIENTUSER = "DELETE_CLIENT_CLIENTUSER";

export const LOAD_JOBROLES = "LOAD_JOBROLES";
export const LOAD_CLIENT_PERMANENTVACANCIES = "LOAD_CLIENT_PERMANENTVACANCIES";
export const LOAD_PERMANENT_VACANCY = "LOAD_PERMANENT_VACANCY";
export const CREATE_PERMANENT_VACANCY = "CREATE_PERMANENT_VACANCY";
export const LOAD_PERMANENT_VACANCIES = "LOAD_PERMANENT_VACANCIES";
export const UPDATE_PERMANENT_VACANCY = "UPDATE_PERMANENT_VACANCY";

export const LOAD_CLIENT_BOOKINGS = "LOAD_CLIENT_BOOKINGS";
export const LOAD_BOOKING = "LOAD_BOOKING";
export const CREATE_BOOKING = "CREATE_BOOKING";
export const LOAD_BOOKINGS = "LOAD_BOOKINGS";
export const UPDATE_BOOKING = "UPDATE_BOOKING";
export const UPDATE_BOOKING_STATUS = "UPDATE_BOOKING_STATUS";
export const UPDATE_BOOKING_FILL = "UPDATE_BOOKING_FILL";
export const UPDATE_BOOKING_SPLIT = "UPDATE_BOOKING_SPLIT";
export const UPDATE_BOOKING_EXTEND = "UPDATE_BOOKING_EXTEND";

export const UPDATE_BOOKING_DATE = "UPDATE_BOOKING_DATE";
export const UPDATE_BOOKING_REMOVEDAY = "UPDATE_BOOKING_REMOVEDAY";
export const UPDATE_BOOKING_INVITE_CANDIDATE =
  "UPDATE_BOOKING_INVITE_CANDIDATE";
export const UPDATE_BOOKING_REJECT_CANDIDATE =
  "UPDATE_BOOKING_REJECT_CANDIDATE";
export const LOAD_CLIENTUSERS_FOR_DROPDOWN = "LOAD_CLIENTUSERS_FOR_DROPDOWN";
export const LOAD_BOOKING_CANDIDATELIST = "LOAD_BOOKING_CANDIDATELIST";

export const UPDATE_CLIENTUSER_CREATEPORTALUSER =
  "UPDATE_CLIENTUSER_CREATEPORTALUSER";
export const LOAD_INTERNAL_NOTIFICATIONS = "LOAD_INTERNAL_NOTIFICATIONS";

export const UPDATE_INTERNAL_NOTIFICATIONS = "UPDATE_INTERNAL_NOTIFICATIONS";
export const UPDATE_INTERNAL_NOTIFICATIONSOWNER =
  "UPDATE_INTERNAL_NOTIFICATIONSOWNER";

export const CREATE_MANUALIDCHECK = "CREATE_MANUALIDCHECK";

export const LOAD_LISTTYPES = "LOAD_LISTTYPES";
export const LOAD_POLICYDOCUMENTS = "LOAD_POLICYDOCUMENTS";

export const UPDATE_CANDIDATE_ARCHIVE = "UPDATE_CANDIDATE_ARCHIVE";
export const UPDATE_CANDIDATE_UNARCHIVE = "UPDATE_CANDIDATE_UNARCHIVE";

export const SEND_CANDIDATE_SAFEGUARDINGPROFILE =
  "SEND_CANDIDATE_SAFEGUARDINGPROFILE";

export const SEND_CLIENT_TEMPLATEEMAIL = "SEND_CLIENT_TEMPLATEEMAIL";
export const SEND_CANDIDATE_TEMPLATEEMAIL = "SEND_CANDIDATE_TEMPLATEEMAIL";

export const LOAD_INVOICESDUE = "LOAD_INVOICESDUE";
export const LOAD_PAYROLLDUE = "LOAD_PAYROLLDUE";
export const LOAD_TIMESHEETSDUE = "LOAD_TIMESHEETSDUE";
export const LOAD_STATS_DAYS = "LOAD_STATS_DAYS";
export const LOAD_STATS_CLIENTCONTACT = "LOAD_STATS_CLIENTCONTACT";
export const LOAD_STATS_CANDIDATES = "LOAD_STATS_CANDIDATES";
export const UPDATE_CANDIDATE_PRIORITY = "UPDATE_CANDIDATE_PRIORITY";
export const UPDATE_CANDIDATE_OWNER = "UPDATE_CANDIDATE_OWNER";
export const LOAD_STATS_RECENTBOOKINGSTATUS = "LOAD_STATS_RECENTBOOKINGSTATUS";

export const LOAD_CLIENTMARKETINGEMAILTEMPLATES =
  "LOAD_CLIENTMARKETINGEMAILTEMPLATES";

export const CREATE_CANDIDATE_SMS = "CREATE_CANDIDATE_SMS";

export const CREATE_CLIENTUSER_SMS = "CREATE_CLIENTUSER_SMS";
export const LOAD_CLIENTUSER_CHAT = "LOAD_CLIENTUSER_CHAT";
export const CREATE_CLIENTUSER_CHAT = "CREATE_CLIENTUSER_CHAT";

export const UPDATE_CANDIDATE_ADDTOXEROPAYROLL =
  "UPDATE_CANDIDATE_ADDTOXEROPAYROLL";

export const LOAD_XEROPAYRUNS = "LOAD_XEROPAYRUNS";
export const UPDATE_BOOKING_RESENDCONFIRMATIONCLIENT =
  "UPDATE_BOOKING_RESENDCONFIRMATIONCLIENT";
export const UPDATE_BOOKING_RESENDCONFIRMATIONCANDIDATE =
  "UPDATE_BOOKING_RESENDCONFIRMATIONCANDIDATE";

export const UPDATE_XEROPAYRUN = "UPDATE_XEROPAYRUN";
export const UPDATE_CLIENT_ADDTOXERO = "UPDATE_CLIENT_ADDTOXERO";

export const UPDATE_IMPORTINVOICESTOXERO = "UPDATE_IMPORTINVOICESTOXERO";

export const UPDATE_CLIENTPREFERENCE_CLIENT = "UPDATE_CLIENTPREFERENCE_CLIENT";
export const UPDATE_CLIENTPREFERENCE_CANDIDATE =
  "UPDATE_CLIENTPREFERENCE_CANDIDATE";
export const UPDATE_CLIENTPREFERENCE_ADDNEW = "UPDATE_CLIENTPREFERENCE_ADDNEW";
export const LOAD_CLIENT_CANDIDATEAVAILABILITY =
  "LOAD_CLIENT_CANDIDATEAVAILABILITY";

export const LOAD_STATS_WEEKONWEEKSTATS = "LOAD_STATS_WEEKONWEEKSTATS";

export const UPDATE_TIMESHEET = "UPDATE_TIMESHEET";
export const UPDATE_BOOKINGRATES = "UPDATE_BOOKINGRATES";

export const UPDATE_PERMANENTVACANCY_REJECT_CANDIDATE =
  "UPDATE_PERMANENTVACANCY_REJECT_CANDIDATE";
export const UPDATE_PERMANENTVACANCY_SELECT_CANDIDATE =
  "UPDATE_PERMANENTVACANCY_SELECT_CANDIDATE";

export const UPDATE_PERM_FILL = "UPDATE_PERM_FILL";
export const UPDATE_PERM_STATUS = "UPDATE_PERM_STATUS";

export const UPDATE_CLIENT_FOLLOWUPDATE = "UPDATE_CLIENT_FOLLOWUPDATE";
export const UPDATE_CLIENT_PRIORITY = "UPDATE_CLIENT_PRIORITY";

export const UPDATE_CANDIDATE_CONVICTIONNOTES =
  "UPDATE_CANDIDATE_CONVICTIONNOTES";
export const UPDATE_CANDIDATE_HEALTHNOTES = "UPDATE_CANDIDATE_HEALTHNOTES";
export const LOAD_BOOKING_CANDIDATELISTONBOARDING =
  "LOAD_BOOKING_CANDIDATELISTONBOARDING";
